import React from "react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  tone?: "light" | "dark";
  label?: string;
};
export function Countdown({
  tone = "light",
  label = "Introductory price expires in"
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    name: "Hours"
  }, {
    value: minutes,
    name: "Min"
  }, {
    value: seconds,
    name: "Sec"
  }];
  const dark = tone === "dark";
  return <div className="mx-auto mt-6 w-full max-w-xl" role="timer" aria-live="off" data-id="element-24" data-mp="3c48qcjilh3gx">
      <p className={`text-center text-sm font-bold uppercase tracking-wider ${dark ? "text-gold" : "text-alert"}`} data-id="element-25" data-mp="3h2a6avkq4mo6">{label}</p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" data-id="element-26" data-mp="372t6gus5l304">
        {units.map((unit, i) => <React.Fragment key={unit.name} data-id="element-27" data-mp="10clbqjtsw6ag" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-28" data-mp="10cuyzzngnzcg">
              <span className={`flex h-16 w-[4.5rem] items-center justify-center rounded-xl font-mono text-4xl font-bold tabular-nums sm:h-20 sm:w-24 sm:text-5xl ${dark ? "bg-white text-navy" : "bg-navy text-white"}`} data-id="element-29" data-mp="15by7ju2ngnp6">
                {String(unit.value).padStart(2, "0")}
              </span>
              <span className={`mt-1.5 text-xs font-semibold uppercase tracking-wide ${dark ? "text-brand-sky" : "text-muted"}`} data-id="element-30" data-mp="17t2imk08ttue">
                {unit.name}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-3 font-mono text-3xl font-bold sm:pt-5 ${dark ? "text-white" : "text-navy"}`} aria-hidden="true" data-id="element-31" data-mp="a3r4dx7pgdjz">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}